export function shouldSubmitSourceSearch(event: { key: string; nativeEvent: { isComposing: boolean; keyCode: number } }, composing: boolean): boolean {
  return event.key === 'Enter' && !composing && !event.nativeEvent.isComposing && event.nativeEvent.keyCode !== 229
}

export type SourceSearchMatch = {match_score?:number|null;match_reason?:string|null;matched_terms?:string[];matched_pages?:number;indexed_pages?:number;document_kind?:string|null;title_matched?:boolean;matched_page_refs?:string[];match_snippets?:{page_ref:string;text:string}[]}

/** Plain text segments only: filenames and excerpts never become HTML. */
export function sourceSearchSegments(text:string,terms:string[]) {
  const usable=[...new Set(terms.filter(Boolean))].sort((a,b)=>b.length-a.length);
  if(!usable.length)return[{text,match:false}];
  const pattern=new RegExp('('+usable.map(term=>term.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')).join('|')+')','gi');
  return text.split(pattern).filter(Boolean).map(part=>({text:part,match:usable.some(term=>term.toLocaleLowerCase()===part.toLocaleLowerCase())}));
}

export function sourceSearchHint(typed:string,applied:string,loading:boolean) {
  if(loading)return applied?`正在搜索“${applied}”…`:'正在加载素材…';
  if(typed.trim()!==applied)return '搜索条件已修改，点击“搜索”或按 Enter 后更新结果。';
  return applied?`“${applied}”的搜索结果 · 按相关性排序，展示文件名与正文命中位置。`:'输入文件名、关键词或描述目标内容，点击“搜索”或按 Enter 检索。';
}
